module.exports = __webpack_public_path__ + "img/warabee2.f4286217.jpg";